import { useRef } from 'react';
import { useSuspenseQuery } from '@tanstack/react-query';
import { searchService } from 'shared/src/api/searchService';
import { queryKey } from '../../../constants/queryKey';

export const useBeautyList = () => {
  const { data } = useSuspenseQuery({
    queryKey: queryKey.beautyQueries(),
    queryFn: searchService.getBeautyQueries,
  });

  // 최초 fetch 데이터 고정 (iOS: initialize 시 1회만 fetch, 이후 불변)
  // invalidateQueries로 인한 백그라운드 refetch가 발생해도 UI 데이터는 변경되지 않음
  const cachedData = useRef(data);

  return { data: cachedData.current };
};
